module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[12]11.2ddf4ef.woff2";